export default "__VITE_ASSET__5bcf920f__"